import { LitElement, html, css } from 'lit'
import { focusTrap } from '../../lib/focus-trap'

export class MegaMenu extends LitElement {
  static styles = css`
    .mega-menu {
      z-index: 2000;
      position: fixed;
      width: 100%;
      background: #fff;
      border-top: 1px solid var(--color-grey-goose);
      left: 0;
    }
  `

  static properties = {
    hide: { type: Boolean },
    id: { type: String },
    top: { type: String },
  }

  connectedCallback() {
    super.connectedCallback()
    this.hide = true
    this.focusTrap = new focusTrap({
      el: this,
      includeActiveElement: true,
      escCallback: () => {
        this._toggle()
      },
    })

    window.MicroBus.on(`${this.id}:toggle`, (e) => {
      console.log('Toggle Mega Menu', this.id, e)
      this._closeOpenMegaMenu()
      this._setTop()
      if (e.detail && e.detail.state) {
        this._toggle(e.detail.state)
      } else {
        this._toggle()
      }
    })

    this.windowClickHandler = (e) => {
      let megaMenu = this
      if (!(megaMenu == e.target || megaMenu.contains(e.target)) && !(e.target.nodeName === 'MEGA-BUTTON')) {
        this._toggle()
      }
    }
  }

  //need both mouse handlers for closing mega menu when mouse leaves
  // this handler handles when the mouse leaves and goes over the body-overlay component
  _mouseHandler(e) {
    if (e?.relatedTarget?.for !== this.id) {
      this._toggle('close')
    }
  }

  disconnectedCallback() {
    super.connectedCallback()
    window.MicroBus.off(`${this.id}:toggle`)
  }

  render() {
    return html`
      <div class="mega-menu" style="top: ${this.top};">
        <slot></slot>
      </div>
      <body-overlay top=${this.top} id="${this.id}-overlay"></body-overlay>
    `
  }

  _setTop() {
    const el = document.querySelector('.js-main-header')
    const height = el.offsetHeight
    this.top = height - 1
    this.top = this.top + 'px'
  }

  _toggle(force) {
    this.hide = !this.hide

    if (force && force === 'open') {
      this.hide = false
    } else if (force && force === 'close') {
      this.hide = true
    }
    document.querySelector(`mega-button[for="${this.id}"]`).setAttribute('aria-expanded', !this.hide)
    this.setAttribute('aria-hidden', this.hide)
    if (!this.hide) {
      this.focusTrap.activate()
      window.addEventListener('click', this.windowClickHandler)
      window.addEventListener('mouseover', this.windowMouseHandler)
      window.MicroBus.emit(`${this.id}-overlay:toggle`, { closeEvent: `${this.id}:toggle`, state: 'open' })
    } else {
      this.focusTrap.deactivate()
      window.removeEventListener('click', this.windowClickHandler)
      window.removeEventListener('mouseover', this.windowMouseHandler)
      window.MicroBus.emit(`${this.id}-overlay:toggle`, { closeEvent: `${this.id}:toggle`, state: 'close' })
    }
  }

  _closeOpenMegaMenu() {
    let openMegaMenu = document.querySelector('mega-menu[aria-hidden="false"]')
    if (openMegaMenu) {
      let openMenuId = openMegaMenu.getAttribute('id')
      if (this.id != openMenuId) {
        window.MicroBus.emit(`${openMenuId}:toggle`)
      }
    }
  }
}
customElements.define('mega-menu', MegaMenu)
